import { HeadTagsConfig } from '@tenants/types/tenant';

/**
 * <head> tag configuration for the AGNT Inc. investor-relations tenant.
 */
export function createHeadTagsConfig(): HeadTagsConfig {
  return {
    defaultTitle: 'AGNT, Inc. — Redefining How the World Works Together',
    defaultMetaDescriptionKey: 'AGNT, Inc. (Nasdaq: AGNT) is a holding company for agent-centric real estate brands including eXp Realty, the world\'s largest independent real estate brokerage.',
  };
}
